import { render, staticRenderFns } from "./AppIndustrieEuropeChine.vue?vue&type=template&id=2da98bbd&scoped=true"
import script from "./AppIndustrieEuropeChine.vue?vue&type=script&lang=js"
export * from "./AppIndustrieEuropeChine.vue?vue&type=script&lang=js"
import style0 from "./AppIndustrieEuropeChine.vue?vue&type=style&index=0&id=2da98bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da98bbd",
  null
  
)

export default component.exports